import {
  Box,
  Card,
  CardBody,
  HStack,
  IconButton,
  Link,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FileListItemState } from "shared/components/file/FileListItemState";
import { getFileListItemStyles } from "shared/components/file/FileListItemStyles";
import { FileState } from "shared/components/file/FileState";
import { FileIcon } from "shared/icons/FileIcon";
import { TrashIcon } from "shared/icons/TrashIcon";
import { formatFileSize } from "shared/utils/FileSizeUtils";

export interface FileListItemProps {
  fileName: string;
  fileSize: number | null | undefined;
  state: FileState;
  progress?: number;
  url?: string;
  error?: string;
  onClickRetry?: () => void;
  onClickRemove?: () => void;
}

export const FileListItem: React.FC<FileListItemProps> = ({
  fileName,
  fileSize,
  state,
  url,
  progress,
  error,
  onClickRetry,
  onClickRemove,
}) => {
  const { t } = useTranslation(["common"]);

  const styles = getFileListItemStyles(state);

  return (
    <Card colorScheme={styles.cardColorScheme} py="0">
      <CardBody px="16px" py="16px">
        <HStack spacing={0} alignItems="flex-start" minWidth={0}>
          <FileIcon mr="16px" />
          <HStack flexWrap="wrap" flex={1} spacing={0} gap="8px" minWidth="0">
            <Box flex={1} flexBasis="400px" overflow="hidden">
              <Link
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
                href={url}
                target="_blank"
                fontWeight={500} // FIXME: https://chakra-ui.com/docs/styled-system/text-and-layer-styles#text-styles
                color="unset"
                textDecoration="none"
              >
                {fileName}
              </Link>
              {fileSize && (
                <Text variant="small" color={styles.secondaryTextColor}>
                  {formatFileSize(fileSize)}
                </Text>
              )}
            </Box>
            <Box flex={1} flexBasis="30%">
              <FileListItemState
                state={state}
                progress={progress}
                onClickRetry={onClickRetry}
                error={error}
              />
            </Box>
          </HStack>
          {onClickRemove && (
            <IconButton
              variant="ghost"
              aria-label={t("common:remove")}
              icon={<TrashIcon w="20px" h="20px" />}
              w="20px"
              h="20px"
              onClick={onClickRemove}
              colorScheme="error"
              color={styles.removeIconColor}
            />
          )}
        </HStack>
      </CardBody>
    </Card>
  );
};
